<template>
  <v-card
      class="rounded-lg">
    <v-card-title class=" mr-3 ml-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/calendar_icon.svg" max-width="25" max-height="25"></v-img>
      {{today}} <span class="primary--text mr-2 ml-2"> {{month}} </span>  {{year}}
      <v-spacer></v-spacer>
    </v-card-title>
    <VCalendarWeekly :weekdays="[6,0,1,2,3,4,5]"  class="rounded-lg mb-1" :show-month-on-first="false"  color="primary" ></VCalendarWeekly>
    <received-notifications :show-title="false" :is-child="true"></received-notifications>
  </v-card>
</template>

<script>
import ReceivedNotifications from "@/views/modulePages/basicInformation/ReceivedNotifications";
export default {
  name: "SCalendar",
  components: {
    ReceivedNotifications
  },
  props: {
    id: {},
  },
  data() {
    return {
      today: null,
      year: null,
      month: null,
      month_name: {
        1: 'فروردین',
        2: 'اردیبهشت',
        3: 'خرداد',
        4: 'تیر',
        5: 'مرداد',
        6: 'شهریور',
        7: 'مهر',
        8: 'آبان',
        9: 'آذر',
        10: 'دی',
        11: 'بهمن',
        12: 'اسفند',
      },
    }
  },
  mounted() {
    this.today = parseInt(this.serverNow.format('jDD'))
    this.month = parseInt(this.serverNow.format('jMM'))
    this.year = parseInt(this.serverNow.format('jYYYY'))
    this.month = this.month_name[this.month]
  },

}
</script>

<style scoped lang="scss"></style>

